// extracted by mini-css-extract-plugin
export default {"NewDataStatsTags":"StatusTags_NewDataStatsTags__1n0Vy","total":"StatusTags_total__cVwKt"};